import { render, staticRenderFns } from "./WaitingListWeb.vue?vue&type=template&id=6b794b06&"
import script from "./WaitingListWeb.js?vue&type=script&lang=js&"
export * from "./WaitingListWeb.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports